import React from "react";
import { Badge } from "../../../components/ui/badge";
import { Button } from "../../../components/ui/button";
import { Play, Heart, ShieldCheck, TrendingUp } from "lucide-react";

interface ProjectHeaderProps {
    title: string;
    category: string;
    price: number;
    currency: string;
    roi: number;
    imageUrl: string;
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({
    title,
    category,
    price,
    currency,
    roi,
    imageUrl,
}) => {
    return (

        <section className="relative rounded-lg w-full aspect-[3/4] sm:aspect-video overflow-hidden group">
            <img
                alt={title}
                className="w-full h-full object-cover"
                src={imageUrl}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-black/40"></div>

            <div className="absolute top-4 left-4 right-4 flex justify-between items-start">
                <Badge className="bg-emerald-500/90 text-white border-none hover:bg-emerald-600/90 backdrop-blur-md uppercase tracking-wider shadow-lg flex items-center gap-1">
                    <ShieldCheck className="w-3 h-3" /> Verified Deal
                </Badge>
                <Button
                    size="icon"
                    variant="outline"
                    className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md border border-white/30 text-white hover:bg-white/30"
                >
                    <Heart className="w-5 h-5" />
                </Button>
            </div>

            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center">
                <Button
                    size="icon"
                    className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-xl border border-white/40 text-white hover:bg-white/40 transition-all shadow-2xl group-hover:scale-105 duration-300"
                >
                    <Play className="w-8 h-8 ml-1 fill-current" />
                </Button>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-6 pb-8 bg-gradient-to-t from-black/90 via-black/60 to-transparent">
                <div className="flex flex-col gap-1 mb-3">
                    <h1 className="text-3xl font-extrabold text-white leading-tight drop-shadow-md">
                        {title}
                    </h1>
                    <p className="text-white/80 text-sm font-medium">
                        {category} • Series A
                    </p>
                </div>

                <div className="flex items-end justify-between border-t border-white/20 pt-3 mt-2">
                    <div>
                        <div className="text-[10px] font-bold text-white/60 uppercase tracking-widest mb-1">
                            Asking Price
                        </div>
                        <div className="text-2xl font-black text-white tracking-tight">
                            ${price.toLocaleString()} <span className="text-sm font-normal text-white/60">{currency}</span>
                        </div>
                    </div>
                    <div className="flex flex-col items-end">
                        <div className="text-[10px] font-bold text-emerald-400 uppercase tracking-widest mb-1 text-right flex items-center gap-1">
                            <TrendingUp className="w-3 h-3" /> +{roi}% vs Mkt
                        </div>
                        <div className="bg-white/10 backdrop-blur-md px-3 py-1 rounded-lg border border-white/10 text-xs font-semibold text-white">
                            Open for Offers
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProjectHeader;
